import React, { forwardRef } from "react";
export const Input = forwardRef(function Input(props, ref) {
  const { label, type, inputClassName } = props;
  return (
    <div className="w-100 m-0 p-0 input-group input-group-sm">
      {label && 
        <span className="input-group-text m-0 p-0 px-2 fw-bolder text-uppercase">
        {label}
        </span>
      }
      <input
        {...props}
        ref={ref}
        type={type ? type : "text"}
        style={{ height: "100%", textAlign: props.align ? props.align : "left" } }
        className={"form-control " + inputClassName}
      />
    </div>
  );
});

export const SearchInput = forwardRef(function SearchInput(props, ref) {
  const { label, type, disabledButton, onClickButton } = props;
  return (
    <div className="w-100 m-0 p-0 input-group input-group-sm text-uppercase">
      {label && <span className="input-group-text m-0 p-0 px-2 fw-bolder text-uppercase">{label}</span>}
      <input
        {...props}
        ref={ref}
        type={type ? type : "text"}
        className="form-control text-uppercase"
      />
      <button
        className="btn btn-sm btn-info"
        disabled={disabledButton}
        onClick={onClickButton}
      >
        <i className="fa fa-search"></i>
      </button>
    </div>
  );
});
// TODO : se puede cambiar el nombre a TextArea para mejor comprensión
export const Textarea = forwardRef(function Textarea(props, ref) {
  const { label, type } = props;
  return (
    <div className="w-100 m-0 p-0 input-group input-group-sm text-uppercase">
      {label && <span className="input-group-text m-0 p-0 px-2 fw-bolder text-uppercase">{label}</span>}
      <textarea
        ref={ref}
        {...props}
        type={type ? type : "text"}
        className="form-control text-uppercase"
      />
    </div>
  );
});

export const Select = forwardRef(function Select(props, ref) {
  const { label, options, children, ...selectProps } = props;
  return (
    <div className="w-100 m-0 p-0 input-group input-group-sm text-uppercase">
      {label && <span className="input-group-text m-0 p-0 px-2 fw-bolder text-uppercase">{label}</span>}
      <select className="form-select py-1 px-2" ref={ref} {...selectProps}>
        {options &&
          options.map((option, index) => (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          ))}

        {children}
      </select>
    </div>
  );
});

export const Radio = forwardRef(function Radio(props, ref) {
  const { label, id, name, inputClassName } = props;
  return (
    <div className="w-100 d-flex align-items-center gap-2 m-0">
      <input {...props} className={"m-0 " + inputClassName} ref={ref} type="radio" name={name} id={id} />
      <label className="m-0" htmlFor={id}>
        {label}
      </label>
    </div>
  );
});

export const Checkbox = forwardRef(function Checkbox(props, ref) {
  const { name, label, id } = props;
  return (
    <div className="w-100 d-flex align-items-center gap-2 m-0">
      <label className="m-0" htmlFor={id}>
        {label}
      </label>
      <input {...props} className="m-0" ref={ref} type="checkbox" name={name} id={id} />
    </div>
  );
});

